import { render, staticRenderFns } from "./tr.vue?vue&type=template&id=6ec4495b&scoped=true"
import script from "./tr.vue?vue&type=script&lang=js"
export * from "./tr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec4495b",
  null
  
)

export default component.exports